import React from "react";
import { X } from "lucide-react";
import LegalDocument from "./LegalDocument";

const LegalDocumentModal = ({ type, onClose }) => {
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-950/80 px-4 py-8 backdrop-blur-sm">
      <div className="relative max-h-[90vh] w-full max-w-5xl overflow-hidden rounded-3xl border border-white/10 bg-slate-950/95 shadow-2xl shadow-cyan-500/20">
        <div className="flex items-center justify-between border-b border-white/10 px-6 py-4">
          <div className="text-sm font-medium text-slate-200" />
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-slate-900 text-slate-300 transition hover:bg-slate-800 hover:text-white"
            aria-label="Close legal document"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="max-h-[calc(90vh-73px)] overflow-y-auto px-4 py-4">
          <LegalDocument type={type} embedded />
        </div>
      </div>
    </div>
  );
};

export default LegalDocumentModal;